"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.validationSchema = (0, yup_1.object)().shape({
    userId: yup_rules_1.dbIdValidationSchema,
    addressId: yup_rules_1.dbIdValidationSchema,
});
//# sourceMappingURL=validation.js.map